import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
`;

export const ButtonArrow = styled.button`
    border:none;
    background:none;
    cursor:pointer;
`;

export const FreeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 100%;
    background-color: rgba(223, 223, 223, 0.7);
    
    button {
      cursor: pointer;
      width: auto;
      background-color: #FF843D;
      border: none;
      color: #131E2E;
      font-size: 0.7em;
      font-weight: bold;
      border-radius: 5px;
      padding: 8px 5px;
      margin: 10px 0;
    }
    
    span {
      text-align: center;
      font-weight: bold;
      color: #ff0000;
      font-size: 0.8em;
      padding-top: 20px;
    }

    button:hover {
      background-color: #121c2c;
      color: #FF843D;
      transition: 0.3s;
      border: 1px solid #FF843D;
    }
`;

export const TextInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LinkArea = styled.a`
  background-color: #FF843D;
  border: none;
  color: #131E2E;
  font-weight: bold;
  border-radius: 5px;
  padding: 5px 10px;

    &:hover{
      text-decoration: underline;
    }
`;

export const Ooppah = styled.span`
  display: inline-block;
  font-weight: bold;
  color: #131E2E;
  font-size: 1.5em;

  ::first-letter{
    color: #FF843D;
  }

`;